import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

// 获取原型对象上的push&replace函数，修改原型对象中的push&replace方法（避免路由冗余导航）
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routerReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function (location) {
  return routerReplace.call(this, location).catch(error => error)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      noHeader: true,
      noFooter: true
    },
    component: () => import('../views/Login.vue'),
  },
   {
    path: '/warning',
    name: 'warning',
    meta: {
      noHeader: true,
      noFooter: true
    },
    component: () => import('../views/Warning.vue'),
  },
  /* 供水报装 */
  {
    path: '/userpacking',  //居民用户报装
    name: 'userpacking',
    meta: {
      has: true,
      path: 'YwJmbz'
    },
    component: () => import('../views/packing/UserPacking.vue'),
  },
  {
    path: '/construction',  //施工临时用水
    name: 'construction',
    meta: {
      has: true,
      path: 'YwSglsysbz'
    },
    component: () => import('../views/packing/Construction.vue'),
  },
  {
    path: '/newproject',  //新建项目报装
    name: 'newproject',
    meta: {
      has: true,
      path: 'YwXjxmbz'
    },
    component: () => import('../views/packing/NewProject.vue'),
  },
  {
    path: '/smallcompany',  //小微企业用水报装
    name: 'smallcompany',
    meta: {
      has: true,
      path: 'YwXwqyysbz'
    },
    component: () => import('../views/packing/SmallCompany.vue'),
  },
  {
    path: '/otherpacking',  //其他供水报装
    name: 'otherpacking',
    meta: {
      has: true,
      path: 'YwQtgsbz'
    },
    component: () => import('../views/packing/OtherPacking.vue'),
  },
  /* 供水报装 */
  /* 居民业务 */
  {
    path: '/newcontract',  //合同新签
    name: 'newcontract',
    meta: {
      has: true,
      path: 'YwJmhtxq'
    },
    component: () => import('../views/business/NewContract.vue'),
  },
  {
    path: '/contracttransfer',  //合同过户
    name: 'contracttransfer',
    meta: {
      has: true,
      path: 'YwJmgh'
    },
    component: () => import('../views/business/ContractTransfer.vue'),
  },
  {
    path: '/peoplechange',  //用水人口变更
    name: 'peoplechange',
    meta: {
      has: true,
      path: 'YwJmysrkbg'
    },
    component: () => import('../views/business/PeopleChange.vue'),
  },
  {
    path: '/usersuspend',  //暂停用水
    name: 'usersuspend',
    meta: {
      has: true,
      path: 'YwJmztys'
    },
    component: () => import('../views/business/UserSuspend.vue'),
  },
  {
    path: '/userrecovery',  //恢复用水
    name: 'userrecovery',
    meta: {
      has: true,
      path: 'YwJmhfys'
    },
    component: () => import('../views/business/UserRecovery.vue'),
  },
  {
    path: '/lowincome',  //低收入群体用水优惠
    name: 'lowincome',
    meta: {
      has: true,
      path: 'YwJmdsrqtysyh'
    },
    component: () => import('../views/business/LowIncome.vue'),
  },
  {
    path: '/numberchange',  //联系方式变更
    name: 'numberchange',
    meta: {
      has: true,
      path: 'YwJmlxfsbg'
    },
    component: () => import('../views/business/NumberChange.vue'),
  },
  {
    path: '/check',  //水表验表申请
    name: 'check',
    meta: {
      has: true,
      path: 'YwJmsbybsq'
    },
    component: () => import('../views/business/Check.vue'),
  },
  {
    path: '/naturechange',  //用水性质变更
    name: 'naturechange',
    meta: {
      has: true,
      path: 'YwJmysxzbg'
    },
    component: () => import('../views/business/NatureChange.vue'),
  },
  /* 居民业务 */
  /* 单位业务 */
  {
    path: '/comsuspend',  //单位暂停用水
    name: 'comsuspend',
    meta: {
      has: true,
      path: 'YwDwztys'
    },
    component: () => import('../views/company/ComSuspend.vue'),
  },
  {
    path: '/comrecovery',  //单位恢复用水
    name: 'comrecovery',
    meta: {
      has: true,
      path: 'YwDwhfys'
    },
    component: () => import('../views/company/ComRecovery.vue'),
  },
  {
    path: '/comtransfer',  //单位过户
    name: 'comtransfer',
    meta: {
      has: true,
      path: 'YwDwgh'
    },
    component: () => import('../views/company/ComTransfer.vue'),
  },
  {
    path: '/infochange',  //信息调整
    name: 'infochange',
    meta: {
      has: true,
      path: 'YwDwXxtz'
    },
    component: () => import('../views/company/InfoChange.vue'),
  },
  /* 单位业务 */
  /* 报事报修 */
  {
    path: '/repair',  //网上报修
    name: 'repair',
    component: () => import('../views/report/Repair.vue'),
  },
  {
    path: '/complaint',  //网上投诉
    name: 'complaint',
    component: () => import('../views/report/Complaint.vue'),
  },
  /* 报事报修 */
  /* 查询业务 */
  {
    path: '/seahistory',  //水费查询
    name: 'seahistory',
    component: () => import('../views/search/SeaHistory.vue'),
  },
  {
    path: '/seawater',  //水费查询
    name: 'seawater',
    component: () => import('../views/search/SeaWater.vue'),
  },
  {
    path: '/searchrecord',  //缴费记录查询
    name: 'searchrecord',
    component: () => import('../views/search/SearchRecord.vue'),
  },
  {
    path: '/invoice',  //电子发票
    name: 'invoice',
    component: () => import('../views/search/Invoice.vue'),
  },
  {
    path: '/userbinding',  //用户绑定
    name: 'userbinding',
    component: () => import('../views/search/UserBinding.vue'),
  },
  {
    path: '/seabusiness',  //业务办理查询
    name: 'seabusiness',
    component: () => import('../views/search/SeaBusiness.vue'),
  },
  /* 查询业务 */
  /* 业务须知 */
  {
    path: '/publicnotice',  //业务须知
    name: 'publicnotice',
    component: () => import('../views/PublicNotice.vue'),
  },
  /* 业务须知 */
]

const router = new VueRouter({
  routes
})

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  //如果去往登录页则放行 
  if (to.path === '/login') {
    next();
  } else {
    // 从本地存储里获取token
    let token = sessionStorage.getItem('token');
    // 判断token是否为空如果为空则跳转到登录页 如果有则放行
    if (token === null || token === '') {
      next({ path: '/login' });
    } else {
      next();
    }
  }
});

export default router
